/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Directive, OnDestroy, Input, ElementRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { ObservableMap, ChangedEvent, Change } from '@typescript-kit/core';

@Directive({
  selector: '[kitTags]',
})
export class TagsDirective implements OnDestroy {

  private readonly element: HTMLElement;

  private _modelChangedSubscription: Subscription;
  private _model: ObservableMap<any>;

  private _prefix: string = '';

  constructor(element: ElementRef, private renderer: Renderer2) {
    this.element = element.nativeElement;
  }

  ngOnDestroy(): void {
    if (this._modelChangedSubscription) {
      this._modelChangedSubscription.unsubscribe();
      this._modelChangedSubscription = null;
    }
  }

  @Input('kitTags')
  set model(model: ObservableMap<any>) {
    if (this._model === model) {
      return;
    }
    if (this._modelChangedSubscription) {
      this._modelChangedSubscription.unsubscribe();
      this.removeTags(this._model);
    }
    this._model = model;
    if (model) {
      this.addTags(model);
      this._modelChangedSubscription = model.changedEvent
        .subscribe((changedEvent: ChangedEvent) => {
          for (const key in changedEvent.changes) {
            if (changedEvent.changes.hasOwnProperty(key)) {
              const change: Change<any> = changedEvent.changes[key];
              if (change.originalValue) {
                this.setTag(key, change.originalValue, false);
              }
              if (change.currentValue) {
                this.setTag(key, change.currentValue, true);
              }
            }
          }
        });
    } else {
      this._modelChangedSubscription = null;
    }
  }

  get model(): ObservableMap<any> {
    return this._model;
  }

  @Input('kitTagsPrefix')
  set prefix(value: string) {
    if (this._prefix === value) {
      return;
    }
    this.removeTags(this.model);
    this._prefix = value;
    this.addTags(this.model);
  }

  get prefix(): string {
    return this._prefix;
  }

  private addTags(model: ObservableMap<any>) {
    model.forEach((value: any, key: string) => {
      this.setTag(key, value, true);
    });
  }

  private removeTags(model: ObservableMap<any>) {
    model.forEach((value: any, key: string) => {
      this.setTag(key, value, false);
    });
  }

  private setTag(key: string, value: any, addTag: boolean) {
    if (key === 'errors' || !value) {
      return;
    }
    if (typeof value === 'string') {
      if (addTag) {
        this.renderer.addClass(this.element, this.getClassName(key, value));
      } else {
        this.renderer.removeClass(this.element, this.getClassName(key, value));
      }
      // } else if (typeof value === 'number') {
      //   this.renderer.setElementClass(this.element, this.getClassName(key, value.toString()), addTag);
    } else if (value instanceof ObservableMap) {
      value.forEach((itemValue: any, itemKey: string) => {
        this.setTag(`${key}-${itemKey}`, itemValue, addTag);
      });
    } else {
      if (addTag) {
        this.renderer.addClass(this.element, this.getClassName(key));
      } else {
        this.renderer.removeClass(this.element, this.getClassName(key));
      }
    }
  }

  private getClassName(...segments: string[]) {
    return `${this.prefix || ''}${segments.join('-')}`;
  }
}
